import Guid from 'guid';

export const isMobileAndTablet = () => {
  let check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);

  const mobileWindowSize = window.outerWidth < 1024;

  return check || mobileWindowSize;
};

export const isMobileApp = () => {
  return localStorage.getItem('MOBILE_APP_IN_USE') === 'true';
};

export const getItemPrice = (item, calculateWithQuantoty = true, calculateWithSupplements = false, calculatePizzaPrice = true) => {
  let itemPrice = item.orderItem.price || 0;

  switch (item.orderItem.discount_type) {
    case 2:
      itemPrice -= (itemPrice * (item.orderItem.discount / 10000));
      break;
    case 1:
      itemPrice -= item.orderItem.discount;
      break;
    default:
      break;
  }

  if (calculateWithQuantoty) {
    itemPrice *= item.orderItem.quantity;
  }

  //if (calculatePizzaPrice) {
    itemPrice = getPizzaPartPrice(itemPrice, item.orderItem.pizza_item_part);
  //}

  if (item.supplements.length > 0 && calculateWithSupplements) {
    item.supplements.forEach((s) => {
      itemPrice += getItemPrice(s, calculateWithQuantoty, calculateWithSupplements, calculatePizzaPrice);
    });
  }

  if (item.lunchItems.length > 0) {
    item.lunchItems.forEach((s) => {
      itemPrice += getItemPrice(s, calculateWithQuantoty, calculateWithSupplements, calculatePizzaPrice);
    });
  }

  return itemPrice;
};

export const getPizzaPartPrice = (price, part) => {
  if (!part || part === '0000000') return price;

  if (part === '1000000') return price;

  if (part === '0100000' || part === '0010000') return price * 0.5;

  return price * 0.25;
};

const menuItemTypesStub = [
  {menu_item_type_id: 1, menu_item_type_code: 'GROUP'},
  {menu_item_type_id: 2, menu_item_type_code: 'ITEM'},
  {menu_item_type_id: 3, menu_item_type_code: 'CATEGORY'},
  {menu_item_type_id: 4, menu_item_type_code: 'PREPARATION_INSTRUCTION'},
  {menu_item_type_id: 5, menu_item_type_code: 'SUPPLEMENT'},
  {menu_item_type_id: 6, menu_item_type_code: 'BUSINESS_LUNCH_CATEGORY'},
  {menu_item_type_id: 7, menu_item_type_code: 'FREE_ITEM'}
];

export const getItemType = (item, menuItemTypes) => {
  if (menuItemTypes.length === 0) {
    menuItemTypes = menuItemTypesStub;
  }

  const type = menuItemTypes.find(i => i.menu_item_type_id === item.menu_item_type_id);
  return type ? type.menu_item_type_code : 0;
};

const DEFAULT_OPTIONS = {
  customPrice: null,
  newQuantity: 1,
  currentOrderItem: null,
  noAdditions: false,
  category: null
};
export const generateOrderItem = (item,
                                  menuItemTypes, options = DEFAULT_OPTIONS) => {
  const guid = (Guid.create()).value;

  let orderItem = null;

  if (options && options.currentOrderItem) {
    orderItem = Object.assign({}, options.currentOrderItem);
  } else {
    orderItem = {
      block_change_price_flg: item.block_change_price_flg,
      dirty_price: item.web_price,
      free_instruction_text: '',
      guest_number: 0,
      guid_code: guid,
      include_vat: 0,
      is_accepted_flg: 0,
      is_business_lunch_flg: item.is_business_lunch_flg || item.is_kiosk_item_flg,
      business_category_id: options.category ? options.category.menu_item_id : null,
      is_chaser: 0,
      is_deleted: 0,
      is_wineglass_flg: 0,
      item_name: item.item_name,
      menu_item_id: item.menu_item_id,
      parent_id: item.parent_id,
      payment_id: 0,
      portion: item.portion,
      price: options.customPrice || item.newPrice || item.web_price || item.regular_price,
      quantity: options.newQuantity || 1,
      web_price: item.web_price,
      show_details_flg: item.show_details_flg,
      split_item_parent_id: 0,
      pizza_item_part: item.pizza_item_part
    };
  }

  if (options.relation) {
    orderItem.price = options.relation.regular_price;
    item.web_price = options.relation.regular_price;
  }

  const isRootItem = !orderItem.parent_id && !orderItem.parent_uid;
  const isShareItem = orderItem.share_id !== null && orderItem.share_index !== null;
  const shareIndexId = (orderItem.share_id !== null && orderItem.share_index !== null) ? `${orderItem.share_id}_${orderItem.share_index}` : null;
  const isShareRootItem = isShareItem && orderItem.free_instruction_text !== null;

  return {
    id: orderItem.order_menu_item_id,
    guidCode: orderItem.guid_code,
    isRootItem: (isRootItem && !isShareItem) || isShareRootItem,
    isShareItem,
    isShareRootItem,
    shareIndexId,
    noAdditions: options.noAdditions || false,
    orderItem: orderItem,
    menuItem: item,
    supplements: [],
    instructions: [],
    freeInstruction: '',
    category: options.category,
    menuItemType: getItemType(item, menuItemTypes),
    lunchItems: [],
    relation: options.relation,
    editAllowed: true
  };

};

export const generateValueCardOrderItem = (res, value_card_number, item, menuItemTypes, price) => {
  const guid = Guid.create().value;

  let orderItem = {
    block_change_price_flg: item.block_change_price_flg,
    dirty_price: price * -1,
    free_instruction_text: "",
    guest_number: 0,
    guid_code: guid,
    include_vat: 0,
    is_accepted_flg: 0,
    is_business_lunch_flg: item.is_business_lunch_flg || item.is_kiosk_item_flg,
    is_chaser: 0,
    is_deleted: 0,
    is_wineglass_flg: 0,
    item_name: item.item_name,
    menu_item_id: item.menu_item_id,
    parent_id: item.parent_id,
    payment_id: 0,
    portion: item.portion,
    price: price * -1,
    quantity: 1,
    web_price: price * -1,
    show_details_flg: item.show_details_flg,
    split_item_parent_id: 0,
    pizza_item_part: item.pizza_item_part,
    value_card_query_transaction_id: res.transactionId,
    value_card_number: value_card_number
  };

  const isRootItem = !orderItem.parent_id && !orderItem.parent_uid;
  const isShareItem =
    orderItem.share_id !== null && orderItem.share_index !== null;
  const shareIndexId =
    orderItem.share_id !== null && orderItem.share_index !== null
      ? `${orderItem.share_id}_${orderItem.share_index}`
      : null;
  const isShareRootItem =
    isShareItem && orderItem.free_instruction_text !== null;

  return {
    id: orderItem.order_menu_item_id,
    guidCode: orderItem.guid_code,
    isRootItem: (isRootItem && !isShareItem) || isShareRootItem,
    isShareItem,
    isShareRootItem,
    shareIndexId,
    noAdditions: false,
    orderItem: orderItem,
    menuItem: item,
    supplements: [],
    instructions: [],
    freeInstruction: "",
    category: "",
    menuItemType: getItemType(item, menuItemTypes),
    lunchItems: [],
    relation: undefined,
    editAllowed: true,
  };
};
